import {UserNames} from "./User";
import {ResourceSharingSettings} from './SharingSettings';

export enum INTEGRATION_TYPE {
  AWS_S3 = 'aws_s3',
  CUSTOM_APP = 'custom_app',
  GDRIVE = 'gdrive',
  GOOGLE_CHAT = 'google_chat',
  MS_TEAMS = 'ms_teams',
  SFTP = 'sftp',
  SLACK = 'slack',
  SMTP = 'smtp',
  TABLEAU = 'tableau',
  OPEN_AI = 'open_ai',
}

export enum INTEGRATION_LOADING_SOURCE {
  /*
   * Integration is loaded in from different places.
   * In case it not from `INTEGRATION` page, we don't need sharing settings and `reports` loaded.
   */
  INTEGRATION = 'integration', // integration list page
  REPORT = 'report',
  LOGS = 'logs',
  OTHER = 'other', // not used
}

export interface Integration {
  id?: string;
  uid?: string;
  name: string;
  type: string;
  config: string;
  config_json?: {
    [key: string]: any;
  };
  encrypted_config: string;
  created_on_utc: string;
  changed_on_utc: string;
  changed_by: UserNames;
  created_by: UserNames;
  reports: string[];
  sharing_settings?: ResourceSharingSettings;
}

export interface TableauWorkbook {
  id: string;
  name: string;
  project_name?: string;
}

export interface TableauView extends TableauWorkbook {
  content_url: string;
  tableau_url: string,
  site_name: string,
  preview_image?: string;
}

export interface TableauCustomView extends TableauWorkbook {
  view_id: string;
}
